import { render, staticRenderFns } from "./assignment-bulk-complete-modal.vue?vue&type=template&id=4c2a59f5"
import script from "./assignment-bulk-complete-modal.vue?vue&type=script&lang=js"
export * from "./assignment-bulk-complete-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports